<script>
import VpnProfilesAction from "./vpn-profiles-action";
import VpnProfilesTable from "./vpn-profiles-table";
import { permissionMixin } from "@/mixins/permissions";

export default {
  name: "VpnProfiles",
  mixins: [permissionMixin],
  components: {
    VpnProfilesAction,
    VpnProfilesTable
  }
};
</script>
<template>
  <div
    class="mb-6"
    v-if="isPermitted(PermissionEnum.OPENVPN_PROFILE.VIEW)"
    id="vpn-profiles__main-container"
  >
    <v-subheader class="title" id="vpn-profiles__main-title">
      <v-icon x-large class="mr-2">mdi-key</v-icon>
      {{ $t("modules.dataPath.vpn.vpnProfiles") }}
    </v-subheader>
    <v-divider></v-divider>
    <vpn-profiles-action />
    <vpn-profiles-table />
  </div>
</template>
